<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Menu BI' : 'Nuovo Menu BI' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-menu-bi-config-form [data]="data"></app-menu-bi-config-form>
</div>
